import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import Pagination from "../generic-ui/Pagination";
import Select from "../generic-ui/Select";
import NavbarIconsCatalogModules from "../generic-nav-bar/NavbarIconsCatalogModules";
import {
  catalogModuleCleanSearchText,
  catalogModuleStartDelete,
  cleanSearchingCatalogModulesPaginated,
  selectCatalogModules,
  startLoadingCatalogModulesPaginated,
  startSearchingCatalogModulePaginated,
} from "../../app/actions/catalogModuleActions";
import SearchBackCatalogModule from "../generic-search/SearchBackCatalogModule";

import { useTracking } from "react-tracking";
import { useTranslation } from "react-i18next";
import TableCatalogModules from "./TableCatalogModules";
import { debugLogPages } from "../../app/helpers/debugHelper";

const ID_FORM = "admin-catalog-module";
const OPERATION = "list";

const listOptions = [2, 3, 4, 5, 10, 15, 20, 25, 50, 100];

const ListCatalogModules = () => {
  debugLogPages(':: ListCatalogModules');

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { trackEvent } = useTracking();
  const { t } = useTranslation();

  const { searchTextState, catalogModulesS, catalogModulesP, totalPagesP, totalItemsP, currentPageP, totalPagesS, totalItemsS, currentPageS } =
    useSelector((state) => state.catalogModule);

  const [, setCurrentPageClick] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [pageInitial] = useState(0);
  const [searchText, setSearchText] = useState(searchTextState || "");

  useEffect(() => {
    //First Clean list and searchText
    dispatch(cleanSearchingCatalogModulesPaginated());
    dispatch(catalogModuleCleanSearchText());
    //Load Data
    dispatch(startLoadingCatalogModulesPaginated(pageInitial, itemsPerPage));
    setSearchText("");
  }, []);

  const onEditRow = (row) => {
    trackEvent({ component: "EditCatalogModules", method: "onEditRow", event: "EditCatalogModules-Clicked" });

    dispatch(selectCatalogModules(row));
    if (catalogModulesS && catalogModulesS.length > 0) {
      navigate("/admin-catalog-module/edit-catalog-module", {
        state: { searchTextNavListUser: searchText },
      });
    } else {
      navigate("/admin-catalog-module/edit-catalog-module");
    }
  };

  const onDeleteRow = (row) => {
    trackEvent({ component: "DeleteCatalogModules", method: "onDeleteRow", event: "DeleteCatalogModules-Clicked" });
    dispatch(catalogModuleStartDelete(row.id));
  };

  const onPageChange = (pageClick) => {
    
    if (catalogModulesS && catalogModulesS.length > 0) {
      dispatch(startSearchingCatalogModulePaginated(searchText, pageClick - 1, itemsPerPage));
    } else {
      dispatch(startLoadingCatalogModulesPaginated(pageClick - 1, itemsPerPage));
    }
    setCurrentPageClick(pageClick);
  };

  const onChangeSelect = (event) => {
    setItemsPerPage(event.target.value);
    if (catalogModulesS && catalogModulesS.length > 0) {
      dispatch(startSearchingCatalogModulePaginated(searchText, 0, event.target.value));
    } else {
      dispatch(startLoadingCatalogModulesPaginated(0, event.target.value));
    }
    setCurrentPageClick(0);
    setItemsPerPage(event.target.value);
  };

  return (
    <>
      <NavbarIconsCatalogModules page={"listCatalogModules"} />

      <div className="d-flex justify-content-center page-title">{t(`${ID_FORM}.page.${OPERATION}`)}</div>

      <hr className="line-hr" />

      <SearchBackCatalogModule searchText={searchText} setSearchText={setSearchText} itemsPerPage={itemsPerPage} />

      {catalogModulesS && catalogModulesS.length > 0 ? (
        <TableCatalogModules data={catalogModulesS} onEditRow={onEditRow} onDeleteRow={onDeleteRow} />
      ) : (
        <TableCatalogModules data={catalogModulesP} onEditRow={onEditRow} onDeleteRow={onDeleteRow} />
      )}

      <div>
        <Select listOptions={listOptions} onChangeSelect={onChangeSelect} pageSize={itemsPerPage} />
      </div>

      <div className="pagination justify-content-center">
        {catalogModulesS && catalogModulesS.length > 0 ? (
          <Pagination
            totalPages={totalPagesS}
            totalItems={totalItemsS}
            currentPage={currentPageS + 1} 
            itemsPerPage={itemsPerPage}
            onPageChange={onPageChange}
          />
        ) : (
          <Pagination
            totalPages={totalPagesP}
            totalItems={totalItemsP}
            currentPage={currentPageP + 1} 
            itemsPerPage={itemsPerPage}
            onPageChange={onPageChange}
          />
        )}
      </div>
    </>
  );
};

export default ListCatalogModules;
